<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container" v-loading="loading">
      <div class="content_title">
        <titleConfig
          :title="langSet == 'cn' ? '产品详情' : 'Product Details'"
          :type="2"
        ></titleConfig>
      </div>
      <div class="content-top flex flex_items_center flex_content_sb">
        <el-image
          v-if="details.exhibitor.logo"
          class="img-wrap"
          :src="details.exhibitor.logo"
          :fit="'contain'"
        ></el-image>
        <img class="img-wrap" v-else src="../../assets/kv.jpg" alt="" />
        <div class="content-text">
          <div class="title">
            {{
              langSet == "cn"
                ? details.exhibitor.companyName
                : details.exhibitor.enCompanyName
            }}
          </div>
          <div class="content-label">
            <span
              v-for="(item, index) in details.exhibitor.productClass_name"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <!-- <div>
            {{ langSet == "cn" ? "展位号" : "Booth No." }}：{{
              details.exhibitor.boothNo
            }}
          </div> -->
          <div>
            {{ langSet == "cn" ? "官网" : "Official Website" }}：{{
              details.exhibitor.officialWebsite
            }}
          </div>
        </div>
        <div class="bus-wrap">
          <div
            class="collect flex flex_items_center flex_content_center"
            :class="{ active: details.exhibitor.is_collect == 1 }"
            @click="toCollect(2, details.exhibitor.id)"
          >
            <span v-if="details.exhibitor.is_collect == 0"
              >{{ langSet == "cn" ? "收藏" : "My Favorites" }} |</span
            >
            <span v-if="details.exhibitor.is_collect == 1"
              >{{ langSet == "cn" ? "已收藏" : "My Favorites" }} |</span
            >
            <img class="icon" src="../../assets/icon_h.png" />
          </div>
          <div class="collect bus-btn" @click="handleShowBusinessInquiry">
            {{ langSet == "cn" ? "商贸洽谈" : "Business Inquiry" }}
          </div>
        </div>
      </div>
      <div class="content-bottom">
        <div class="title">
          {{ langSet == "cn" ? "产品简介" : "Company Profile" }}
        </div>
        <div class="flex">
          <div class="content-img" v-if="details.imgs.length > 0">
            <el-image
              class="img"
              :src="details.imgs[0].url"
              :fit="'contain'"
            ></el-image>
          </div>
          <div class="content-main">
            <div class="goods-name">
              {{ langSet == "cn" ? details.goodsName : details.en_goodsName }}
            </div>
            <div class="btn-wrap flex">
              <div
                class="btn flex flex_items_center flex_content_center"
                :class="{ active: details.is_collect == 1 }"
                @click="toCollect(1, details.id)"
              >
                <span v-if="details.is_collect == 0"
                  >{{ langSet == "cn" ? "收藏" : "My Favorites" }} |</span
                >
                <span v-if="details.is_collect == 1"
                  >{{ langSet == "cn" ? "已收藏" : "My Favorites" }} |</span
                >
                <img class="icon" src="../../assets/icon_h.png" />
              </div>
              <div class="btn btn-green" @click="request">
                {{ langSet == "cn" ? "索取样品" : "Sample Request" }}
              </div>
            </div>
            <div class="flex">
              <div class="text-title">
                {{ langSet == "cn" ? "CAS号" : "CAS No." }}：
              </div>
              <div class="text-introduction">{{ details.cas_code }}</div>
            </div>
            <div class="flex">
              <div class="text-title">
                {{
                  langSet == "cn"
                    ? "备案状态"
                    : "Record on CDE Information Disclosure"
                }}：
              </div>
              <div class="text-introduction">{{ langSet == 'cn' ? details._filing_status : details._filing_status_en}}</div>
            </div>
            <div class="flex">
              <div class="text-title">
                {{ langSet == "cn" ? "产品描述" : "Product Introduction" }}：
              </div>
              <div class="text-introduction">{{ langSet == 'cn' ? details.introduction : details.en_introduction }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-subtitle flex flex_content_sb">
        <titleConfig
          :title="langSet == 'cn' ? '产品推荐' : 'Product Recommendations'"
          :type="2"
        ></titleConfig>
        <div
          class="btn-slide btn-slide-right small-btn flex_content_center flex_items_center"
          @click="toMore"
        >
          <div class="btn-main">
            {{ langSet == "cn" ? "查看更多" : "Details"
            }}<span class="icon"></span>
          </div>
        </div>
      </div>
      <productList :productLists="list"></productList>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <div class="dialog-wrap">
        <el-image
          v-if="details.exhibitor.qrcode_img"
          class="qrcode"
          :src="details.exhibitor.qrcode_img"
          :fit="'cover'"
        ></el-image>
        <p>扫码进行线上沟通</p>
      </div>
    </el-dialog>
    <!-- 底部 -->
    <bottom></bottom>
    <AskingForSamples
      @add_request="request"
      :details="details"
      :dialog_release="Samples_dialogVisible"
    ></AskingForSamples>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import productList from "./component/product_list.vue";
import AskingForSamples from "./component/AskingForSamples.vue";
import { productLists, productDetail } from "@/api/product_api";
import { collect } from "@/api/api";
import { sdkClick, sdkTime } from "../../sdk/useSdk";
import router from "@/router";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    productList,
    AskingForSamples,
  },
  data() {
    return {
      langSet: "",
      loading: false,
      id: 0,
      flag: "",
      type: 0,
      details: {
        exhibitor: {},
        imgs: [],
      },
      metaData: {},
      list: [],
      dialogVisible: false,
      Samples_dialogVisible: false,
      // 埋点
      timeKeeping: 0,
      interval: null,
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.flag = localStorage.getItem("Flag") || "";
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    //25.9.18 获取详情 dxm
    this.getDetails(this.id);
    let interval = setInterval(() => {
      this.timeKeeping = this.timeKeeping + 1;
    }, 1000);
    this.interval = interval;
    window.addEventListener("beforeunload", this.stopTimeKeeping);
  },
  beforeDestroy() {
    this.stopTimeKeeping();
    window.removeEventListener("beforeunload", this.stopTimeKeeping);
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getDetails(id) {
      let data = {
        id,
      };
      this.loading = true;
      const res = await productDetail(data);
      this.details = res.data;
      this.loading = false;
      if (this.details.companyid) {
        this.getList();
      }
    },
    async getList() {
      let data = {
        companyid: this.details.companyid,
        page_size: 6,
      };
      const res = await productLists(data);
      this.list = res.data.lists;
    },
    async toCollect(type, id) {
      let status;
      if (type == 1) {
        status = this.details.is_collect == 0 ? 1 : 0;
        if (status == 1) {
          sdkClick(
            "收藏产品",
            this.details.exhibitor.companyName + ">>" + this.details.goodsName
          );
        }
      } else {
        status = this.details.exhibitor.is_collect == 0 ? 1 : 0;
        if (status == 1) {
          sdkClick(
            "收藏展商",
            this.details.exhibitor.companyName + ">>" + this.details.goodsName
          );
        }
      }
      let data = {
        type,
        dataId: id,
        status,
      };
      const res = await collect(data);
      if (res.code == 1) {
        if (type == 1) {
          this.$message.success(
            this.details.is_collect == 0 ? "收藏成功" : "取消收藏成功"
          );
          this.details.is_collect = this.details.is_collect == 0 ? 1 : 0;
        } else {
          this.$message.success(
            this.details.exhibitor.is_collect == 0 ? "收藏成功" : "取消收藏成功"
          );
          this.details.exhibitor.is_collect =
            this.details.exhibitor.is_collect == 0 ? 1 : 0;
        }
      }
    },
    request() {
      if (this.flag == "isLogin") {
        this.Samples_dialogVisible = !this.Samples_dialogVisible;
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    toMore() {
      this.$router.push({
        path: "/featuredProducts",
        query: {
          id: this.details.companyid,
        },
      });
    },
    stopTimeKeeping() {
      sdkTime(
        "浏览展品",
        this.details.exhibitor.companyName + ">>" + this.details.goodsName,
        this.timeKeeping
      );
      clearInterval(this.interval);
    },
    handleShowBusinessInquiry() {
      this.dialogVisible = true;
      sdkClick(
        "商贸洽谈",
        this.details.exhibitor.companyName + ">>" + this.details.goodsName
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  padding: 80px 0;
  .content_title {
    margin-bottom: 30px;
  }
  .content-top {
    padding: 20px 30px;
    background: #f9fafc;
    border-radius: 30px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #001a33;
    line-height: 20px;
    position: relative;
    .collect {
      padding: 0 10px;
      min-width: 124px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      text-align: center;
      line-height: 40px;
      background: #77a5e6;
      border-radius: 8px;
      box-sizing: border-box;
      &:hover {
        background: #1d2379;
      }
      .icon {
        width: 15px;
        height: 15px;
        margin-left: 7px;
      }
    }
    .bus-btn {
      margin-top: 15px;
      opacity: 0.8;
      background: #90c31f !important;
      &:hover {
        opacity: 1;
      }
    }
    .active {
      background: #1d2379;
    }
    .img-wrap {
      width: 190px;
      height: 125px;
      margin-right: 20px;
      background: #fff;
    }
    .content-text {
      flex: 1;
      & > div {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .title {
        font-weight: 500;
        font-size: 20px;
        color: #001a33;
        line-height: 28px;
      }
      .content-label {
        span {
          height: 18px;
          padding: 0 10px;
          font-size: 12px;
          color: #447bce;
          line-height: 18px;
          background: #dfe7f1;
          border-radius: 4px;
        }
      }
    }
  }
  .content-bottom {
    padding: 30px;
    background: #f9fafc;
    border-radius: 30px;
    /deep/ p img {
      max-width: 100%;
      display: inline-block;
    }
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #001a33;
      line-height: 25px;
      padding-bottom: 10px;
    }
    .content-img {
      width: 280px;
      height: 190px;
      background: #fff;
      margin-right: 30px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .content-main {
      flex: 1;
      font-size: 15px;
      color: #2c2c2e;
      line-height: 21px;
      & > div {
        margin-bottom: 9px;
      }
      .goods-name {
        font-weight: 500;
        font-size: 20px;
        color: #2c2c2e;
        line-height: 28px;
        margin-bottom: 20px;
      }
      .btn-wrap {
        .btn {
          width: 124px;
          height: 40px;
          color: #fff;
          cursor: pointer;
          text-align: center;
          line-height: 40px;
          background: #77a5e6;
          border-radius: 8px;
          margin-bottom: 20px;
          opacity: 0.9;
          &:hover {
            opacity: 1;
          }
        }
        .active {
          background: #1d2379;
        }
        .btn-green {
          margin-left: 15px;
          background: #90c31f;
        }
        .icon {
          width: 15px;
          margin-left: 10px;
        }
      }
      .text-title {
        width: 85px;
      }
      .text-introduction {
        flex: 1;
      }
    }
  }
  .content-subtitle {
    padding: 50px 0 30px;
  }
}
.dialog-wrap {
  font-size: 14px;
  text-align: center;
  color: rgb(255, 60, 60);
  .qrcode {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .content-top {
      flex-wrap: wrap;
      padding: 0.29rem;
      border-radius: 10px;
      font-size: 0.23rem;
      line-height: 0.33rem;
      .img-wrap {
        width: 3.65rem;
        height: 2.4rem;
      }
      .content-text {
        margin: 0.29rem 0 0.38rem;
        .title {
          font-size: 0.31rem;
          line-height: 0.42rem;
        }
      }
      .bus-wrap {
        width: 100%;
        display: flex;
        .collect {
          width: 2.92rem;
          height: 0.77rem;
          line-height: 0.77rem;
        }
        .bus-btn {
          margin-top: 0;
          margin-left: 0.3rem;
        }
      }
    }
    .content-bottom {
      padding: 0.38rem 0.29rem;
      .content-img {
        width: 100%;
        height: 100%;
        margin-right: 0;
      }
      & > .flex {
        flex-wrap: wrap;
      }
      .content-main {
        font-size: 0.29rem;
        line-height: 0.46rem;
        position: relative;
        padding-bottom: 1rem;
        .goods-name {
          font-size: 0.31rem;
          line-height: 0.42rem;
          margin-top: 0.29rem;
          margin-bottom: 0.19rem;
        }
        .text-title {
          width: 1.5rem;
        }
        .btn-wrap {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          margin-bottom: 0;
          .btn {
            width: 2.9rem;
            height: 0.77rem;
            line-height: 0.77rem;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>